import React from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';

const Wrapper = (props) => {
  const { url } = props;
  const CustomRowComponent = ((compClass, displayName) => {
    if (!displayName) {
      throw new Error('No displayName found for template component:', compClass);
    }
    const cmp = ({ children, className, typeOfSearch, ...rest }) => {
      let id;
      switch (typeOfSearch) {
        case 'publicHash':
          id = children[0].props.children[0].props.children.props.original.shareLink;
          break;
        default:
          id = children[0].props.children[0].props.children.props.original.id;
      }
      return Array.isArray(children) ? (
        <Link to={`${url}${id}`} className={cn('searchresult__item', compClass, className)} {...rest}>
          {children}
        </Link>
      ) : (
        <div className={cn(compClass, className)} {...rest}>
          {children}
        </div>
      );
    };
    cmp.displayName = displayName;
    return cmp;
  })('rt-tr-group', 'TrGroup');

  return <CustomRowComponent {...props} />;
};

export default Wrapper;
